export var HOME_IDS = {
  SHARED_ID: 'shared',
  TRENDING_ID: 'trending',
  TOPICS_ID: 'topics',
  YOU_MIGHT_LIKE_ID: 'youMightLike',
  RECENTLY_VIEWED_ID: 'recentlyViewed',
  RECENTLY_ADDED_ID: 'recentlyAdded',
  FEATURED_CONTENT_ID: 'featureContent'
};